import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { forkJoin, Observable, map } from 'rxjs';
import { environment } from '../environments/environment';

const TRANSLATION_FILES = ['common', 'auth', 'dashboard', 'settings', 'admin', 'journal', 'goals'];

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient);

  getTranslation(lang: string): Observable<Translation> {
    const requests = TRANSLATION_FILES.map(file =>
      this.http.get<Translation>(`${environment.assetsUrl}/i18n/${lang}/${file}.json`)
    );
    return forkJoin(requests).pipe(
      map(results => Object.assign({}, ...results))
    );
  }
}
